import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { supportedLngs } from '../../../libraries/i18n/i18n';
import { cn } from '../../../../common-utils/libraries/tailwind/utils';

/**
 * @param root0
 * @param root0.className
 * @returns {JSX} LocalePicker
 */
function LocalePicker({ className }) {
    const { i18n } = useTranslation();

    return (
        <select
            id='locale-picker'
            className={cn('focus:outline-none focus:ring-0 select-none bg-transparent', className)}
            value={i18n.resolvedLanguage}
            onChange={(e) => i18n.changeLanguage(e.target.value)}
        >
            {Object.entries(supportedLngs).map(([lang, name]) => (
                <option value={lang} key={lang}>
                    {name}
                </option>
            ))}
        </select>
    );
}
LocalePicker.propTypes = {
    className: PropTypes.string
};

export default LocalePicker;